import IntlConfigContext from 'src/internal/config/IntlConfigContext';

import type {ReactElement, ReactNode} from 'react';
import type {IntlConfig} from 'src/types';

type Props = {
  children: ReactNode;
  config: IntlConfig;
};

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-intl/api/IntlProvider
 */
export default function IntlProvider({children, config}: Props): ReactElement {
  return (
    <IntlConfigContext.Provider value={config}>
      {children}
    </IntlConfigContext.Provider>
  );
}
